<template>
  <div class="q-pa-sm full-height tenant-biz-callback">
    <rs-form ref="form" allDirty name="erp-callback" label-width="11em" @change="onChange">
      <rs-field type="group" :label="$t_s('baseInfo')">
        <rs-field name="id" :hidden="!id"></rs-field>
        <rs-field name="tenant" :widget="{ returnAllAttrs: true }"></rs-field>
        <rs-field name="topicSuffix" :readonly="true"></rs-field>
        <rs-field name="erpName"></rs-field>
        <rs-field name="info"></rs-field>
      </rs-field>
      <rs-field type="group" ignore name="events">
        <rs-cascades
          ref="eventList"
          :loadDefault="id"
          add-model="erp-event"
          :on-select="onEventSelect"
          :convertInitList="convertInitList"
        >
          <rs-field name="event.id" :editable="false"></rs-field>
          <rs-field name="event.name" :editable="false"></rs-field>
          <rs-field name="configs"></rs-field>
          <rs-field type="toolbar"></rs-field>
        </rs-cascades>
      </rs-field>
      <rs-toolbar></rs-toolbar>
    </rs-form>
  </div>
</template>
<script>
import { cloneDeep } from "lodash";

export default {
  components: {},
  data: function() {
    return {
      id: this.$route.query.id,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    onChange(val, fireKey, core) {
      // 修改租户 设置 kafka消息topic后缀 默认是租户代号
      if (fireKey.length === 1 && fireKey[0] === "tenant") {
        setTimeout(() => {
          core.setValue({ topicSuffix: (val.tenant?.uname || "").toUpperCase() });
        });
      }
    },
    convertInitList(list) {
      return list.map((d) => {
        if (d.configs && typeof d.configs === "object") {
          d.configs = JSON.stringify(d.configs);
        }
        return d;
      });
    },
    beforeSubmit(e, params) {
      const p = cloneDeep(params);
      if (p.tenant) {
        p.tenant = { id: p.tenant.id, name: p.tenant.name };
      }
      return {
        params: p,
        resolve: ({ response }) => {
          let id = this.id;
          if (response && response.content && response.content.id) {
            id = response.content.id;
          }
          this.$refs.eventList.save(id, (data) => {
            if (data?.length) {
              data.forEach((d) => {
                if (typeof d.configs === "string") {
                  try {
                    d.configs = JSON.parse(d.configs);
                  } catch (error) {
                    d.configs = null;
                  }
                }
              });
            }
            return data;
          });
          this.$rs_actionRefresh("tenants.erpCallback._view");
        },
      };
    },
    onEventSelect(data) {
      return {
        event: { id: data.id, name: data.name },
        configs: null,
      };
    },
  },
};
</script>
